import IdentityVerification from 'ui/sections/notarize/pages/IdentityVerification';
import { NotarizationStatus } from 'utils/enums';

export default class SpouseIdentityVerification extends IdentityVerification {
  static forSpouse = true;
  static notarizationSection = NotarizationStatus.KBA_SPOUSE;
}
